import { axiosInstance } from '../../../shared/api';

export const createFinancialGoal = async goalData => {
	try {
		const response = await axiosInstance.post(`goals`, goalData, {
			withCredentials: true,
			headers: {
				Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
			},
		});

		return response.data;
	} catch (error) {
		console.error('API Error:', error);
		if (error.response) {
			console.error('Error response data:', error.response.data);
			console.error('Error response status:', error.response.status);
			console.error('Error response headers:', error.response.headers);
			// Handle both string detail (HTTPException) and array detail (Pydantic validation)
			let errorMessage;
			if (typeof error.response.data?.detail === 'string') {
				errorMessage = error.response.data.detail;
			} else if (
				Array.isArray(error.response.data?.detail) &&
				error.response.data.detail.length > 0
			) {
				errorMessage = error.response.data.detail[0].msg;
			} else {
				errorMessage =
					error.response.data?.message ||
					`Server error: ${error.response.status}` ||
					'Failed to create goal';
			}
			throw new Error(errorMessage);
		} else if (error.request) {
			console.error('No response received:', error.request);
			throw new Error('No response from server. Please check your connection.');
		} else {
			console.error('Error setting up request:', error.message);
			throw new Error(`Request error: ${error.message}`);
		}
	}
};

export const getGoalsRequest = async () => {
	try {
		const response = await axiosInstance.get(`goals`, {
			withCredentials: true,
			headers: {
				Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
			},
		});
		return response.data;
	} catch (error) {
		console.error('Error fetching goals:', error);
		throw error;
	}
};

export const updateFinancialGoal = async (goalId, goalData) => {
	try {
		const response = await axiosInstance.put(`goals/${goalId}`, goalData, {
			withCredentials: true,
			headers: {
				Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
			},
		});
		return response.data;
	} catch (error) {
		console.error('API Error updating goal:', error);

		if (error.response) {
			console.error('Error response data:', error.response.data);
			console.error('Error response status:', error.response.status);

			// Handle both string detail (HTTPException) and array detail (Pydantic validation)
			let errorMessage;
			if (typeof error.response.data?.detail === 'string') {
				errorMessage = error.response.data.detail;
			} else if (
				Array.isArray(error.response.data?.detail) &&
				error.response.data.detail.length > 0
			) {
				errorMessage = error.response.data.detail[0].msg;
			} else {
				errorMessage =
					error.response.data?.message ||
					`Server error: ${error.response.status}` ||
					'Failed to update goal';
			}
			throw new Error(errorMessage);
		} else if (error.request) {
			console.error('No response received:', error.request);
			throw new Error('No response from server. Please check your connection.');
		} else {
			console.error('Error setting up request:', error.message);
			throw new Error(`Request error: ${error.message}`);
		}
	}
};

export const addContributionToGoal = async (goalId, contributionData) => {
	try {
		const response = await axiosInstance.post(
			`goals/${goalId}/contributions`,
			contributionData,
			{
				withCredentials: true,
				headers: {
					Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
				},
			},
		);
		return response.data;
	} catch (error) {
		console.error('API Error adding contribution:', error);

		if (error.response) {
			// Handle both string detail (HTTPException) and array detail (Pydantic validation)
			let errorMessage;
			if (typeof error.response.data?.detail === 'string') {
				errorMessage = error.response.data.detail;
			} else if (
				Array.isArray(error.response.data?.detail) &&
				error.response.data.detail.length > 0
			) {
				errorMessage = error.response.data.detail[0].msg;
			} else {
				errorMessage =
					error.response.data?.message ||
					`Server error: ${error.response.status}` ||
					'Failed to add contribution';
			}
			throw new Error(errorMessage);
		} else if (error.request) {
			throw new Error('No response from server. Please check your connection.');
		} else {
			throw new Error(`Request error: ${error.message}`);
		}
	}
};

export const deleteFinancialGoal = async goalId => {
	try {
		const response = await axiosInstance.delete(`goals/${goalId}`, {
			withCredentials: true,
			headers: {
				Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
			},
		});
		return response.data;
	} catch (error) {
		console.error('API Error deleting goal:', error);

		if (error.response) {
			throw new Error(
				error.response.data?.detail ||
					error.response.data?.message ||
					`Server error: ${error.response.status}` ||
					'Failed to delete goal',
			);
		} else if (error.request) {
			throw new Error('No response from server. Please check your connection.');
		} else {
			throw new Error(`Request error: ${error.message}`);
		}
	}
};

export const uploadGoalPicture = async (goalId, file) => {
	try {
		const formData = new FormData();
		formData.append('picture', file);

		const response = await axiosInstance.post(
			`goals/${goalId}/picture`,
			formData,
			{
				withCredentials: true,
				headers: {
					Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
					'Content-Type': 'multipart/form-data',
				},
			},
		);
		return response.data;
	} catch (error) {
		console.error('API Error uploading goal picture:', error);
		if (error.response) {
			throw new Error(
				error.response.data?.detail ||
					error.response.data?.message ||
					`Server error: ${error.response.status}` ||
					'Failed to upload picture',
			);
		} else if (error.request) {
			throw new Error('No response from server. Please check your connection.');
		} else {
			throw new Error(`Request error: ${error.message}`);
		}
	}
};

export const deleteGoalPicture = async goalId => {
	try {
		const response = await axiosInstance.delete(`goals/${goalId}/picture`, {
			withCredentials: true,
			headers: {
				Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
			},
		});
		return response.data;
	} catch (error) {
		console.error('API Error deleting goal picture:', error);
		if (error.response) {
			throw new Error(
				error.response.data?.detail ||
					error.response.data?.message ||
					`Server error: ${error.response.status}` ||
					'Failed to delete picture',
			);
		} else if (error.request) {
			throw new Error('No response from server. Please check your connection.');
		} else {
			throw new Error(`Request error: ${error.message}`);
		}
	}
};

export const getGoalContributions = async (goalId, skip = 0, limit = 100) => {
	try {
		const response = await axiosInstance.get(
			`goals/${goalId}/contributions?skip=${skip}&limit=${limit}`,
			{
				withCredentials: true,
				headers: {
					Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
				},
			},
		);
		return response.data;
	} catch (error) {
		console.error('Error fetching contributions:', error);
		throw error;
	}
};

export const deleteContribution = async (goalId, contributionId) => {
	try {
		const response = await axiosInstance.delete(
			`goals/${goalId}/contributions/${contributionId}`,
			{
				withCredentials: true,
				headers: {
					Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
				},
			},
		);
		return response.data;
	} catch (error) {
		console.error('API Error deleting contribution:', error);
		if (error.response) {
			throw new Error(
				error.response.data?.detail ||
					error.response.data?.message ||
					`Server error: ${error.response.status}` ||
					'Failed to delete contribution',
			);
		} else if (error.request) {
			throw new Error('No response from server. Please check your connection.');
		} else {
			throw new Error(`Request error: ${error.message}`);
		}
	}
};

export const activateGoal = async goalId => {
	try {
		const response = await axiosInstance.patch(
			`goals/${goalId}/activate`,
			{},
			{
				withCredentials: true,
				headers: {
					Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
				},
			},
		);
		return response.data;
	} catch (error) {
		console.error('API Error activating goal:', error);
		if (error.response) {
			throw new Error(
				error.response.data?.detail ||
					error.response.data?.message ||
					`Server error: ${error.response.status}` ||
					'Failed to activate goal',
			);
		} else if (error.request) {
			throw new Error('No response from server. Please check your connection.');
		} else {
			throw new Error(`Request error: ${error.message}`);
		}
	}
};

export const deactivateGoal = async goalId => {
	try {
		const response = await axiosInstance.patch(
			`goals/${goalId}/deactivate`,
			{},
			{
				withCredentials: true,
				headers: {
					Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
				},
			},
		);
		return response.data;
	} catch (error) {
		console.error('API Error deactivating goal:', error);
		if (error.response) {
			throw new Error(
				error.response.data?.detail ||
					error.response.data?.message ||
					`Server error: ${error.response.status}` ||
					'Failed to deactivate goal',
			);
		} else if (error.request) {
			throw new Error('No response from server. Please check your connection.');
		} else {
			throw new Error(`Request error: ${error.message}`);
		}
	}
};
